import { IntentSelectionInput } from '@varo/graphql-schema-types';
import { TFunction } from 'i18next';
import { IllustrationKeyType } from 'shared/components/vxl/Illustration/Illustration';

export const getIntentOptions = (t: TFunction) => {
  return [
    {
      id: IntentSelectionInput.GeneralBanking,
      labelText: t('optionOne.labelText'),
      illustration: 'COINS_A' as IllustrationKeyType,
      analyticsSurveyOption: 'no_fee_account',
    },
    {
      id: IntentSelectionInput.EarlyPayday,
      labelText: t('optionTwo.labelText'),
      illustration: 'PAYCHECK_A' as IllustrationKeyType,
      analyticsSurveyOption: 'early_direct_deposit',
    },
    {
      id: IntentSelectionInput.VaroAdvance,
      labelText: t('optionThree.labelText'),
      illustration: 'CASH_A' as IllustrationKeyType,
      analyticsSurveyOption: 'borrow_cash ',
    },
    {
      id: IntentSelectionInput.HySavings,
      labelText: t('optionFour.labelText'),
      illustration: 'PIGGY_BANK_A' as IllustrationKeyType,
      analyticsSurveyOption: 'build_savings',
    },
    {
      id: IntentSelectionInput.CreditBuilding,
      labelText: t('optionFive.labelText'),
      illustration: 'GAUGE_A' as IllustrationKeyType,
      analyticsSurveyOption: 'improve_credit_score',
    },
    {
      id: IntentSelectionInput.FinancialInsights,
      labelText: t('optionSix.labelText'),
      illustration: 'CALENDAR_A' as IllustrationKeyType,
      analyticsSurveyOption: 'financial_insights',
    },
  ];
};
